export default {
  isLoading: false,
  isOpenModalEditarScheduler: false,
  isOpenModalEliminarAppointment: false,
  isEditAppointment: false,
  appointment: {
    id: 0,
    text: '',
		allDay: false,
		startDate: null,
		endDate: null,
		repeatOnOff: false,
		repeat: 0,
	  repeatEndDate: null,
		centers: []
  },
  defaultTotalCupos: 15,
  listaAppointments: null,
  listaCentros: [],
};
